import { useApiClient } from '@brewardapp/api-client';
import { Loader } from '@breward/ui';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { StylePageContent } from './StylePageContent';

interface ShowStylePageProps {
    styleId?: string;
}

export const ShowStylePage = ({ styleId }: ShowStylePageProps) => {
    const params = useParams();
    const navigate = useNavigate();
    const api = useApiClient();
    const { i18n } = useTranslation();
    // The API localizes names and labels by this param, not by the language picked in the UI.
    const locale = i18n.language?.split('-')[0] || 'pl';

    const { data: styleData, isLoading } = api.styles.useFindStyle(
        {
            filter: {
                id: styleId || params?.id as string,
            },
            include: 'scoresheetSchema',
            locale,
        },
        { enabled: !!(styleId || params?.id) },
    );

    // Fetch the "Metryczka PSPD" scoresheet schema for rule definitions
    const { data: scoresheetSchemasData, isLoading: schemasLoading } =
        api.scoresheetSchemas.useListScoresheetSchemas({
            filter: {
                state: 'approved',
            },
            // Polish is the base language, so the schema is always found by its Polish name.
            locale: 'pl',
        });

    const metryczkaSchema = (scoresheetSchemasData as any)?.data?.find(
        (schema: any) => schema.name === 'Metryczka PSPD'
    );

    const { data: scoresheetSchemaData, isLoading: schemaLoading } =
        api.scoresheetSchemas.useFindScoresheetSchema(
            {
                filter: {
                    id: metryczkaSchema?.id,
                },
                locale,
            },
            {
                enabled: !!metryczkaSchema?.id,
            },
        );

    if (isLoading || schemasLoading || schemaLoading) {
        return <Loader />;
    }

    const style = (styleData as any)?.data;
    const schemaData = scoresheetSchemaData as any;

    const handleBack = () => {
        const isInitialPage = !window.history.state || window.history.state.idx === 0 || window.history.length <= 1;
        if (isInitialPage) {
            window.close();
        } else {
            navigate(-1);
        }
    };

    return <StylePageContent style={style} schemaData={schemaData} onBack={handleBack} />;
};

export default ShowStylePage;